import {
  CampaignColumn,
  useListCampaignColumns,
} from 'services/campaignColumns'

import { campaignColumnHasPendingCompute } from './campaignColumnProgress'

/**
 * Wraps the campaign-columns query and turns on polling whenever any column
 * still has work in flight (computed + failed < total_contacts), so the
 * per-column progress indicator (`5/17 computing…`) tracks reality without
 * relying on a manual refresh.
 */
export function useCampaignColumns(
  campaignId: number,
  options?: { enabled?: boolean }
) {
  const columnsQuery = useListCampaignColumns(campaignId, {
    enabled: options?.enabled !== false,
    refetchInterval: (query) => {
      const data = query.state.data?.results ?? []
      const anyInFlight = data.some(campaignColumnHasPendingCompute)
      return anyInFlight ? 5000 : false
    },
  })
  const columns: CampaignColumn[] = columnsQuery.data?.results ?? []

  return {
    columns,
    isLoading: columnsQuery.isLoading,
    refetch: columnsQuery.refetch,
  }
}
